export const minimalistTheme = {
  branding: {
    primary: "#6400FF",
  },
  shopping_cart: {
    background_color: "#FAFBFC",
    font_color: "#282A30",
    description: {
      font_color: "#92959B",
    },
    information: {
      background_color: "#FFFFFF",
    },
  },
  checkout_font: {
    font_family: "Inter",
  },
  payment_form: {
    field: {
      style: "rounded",
      background_color: "#f9fafb",
      font_color: "#282A30",
      placeholder_color: "#92959B",
      font_size: 14,
      font_weight: "400",
      name: {
        display: "yes",
        font_color: "#282A30",
        font_size: 14,
        font_weight: "400",
      },
    },
    selector: {
      style: "bullet",
      background_color: "#FCFCFF",
      border_color: "#BFC2C7",
      thickness: 1,
    },
    settings: {
      background_color: "#FFFFFF",
      font_color: "#282A30",
      font_size: 14,
      font_weight: "400",
    },
    button: {
      style: "rounded",
      background_color: "#6400FF",
      font_color: "#FFFFFF",
      font_size: 16,
      font_weight: "500",
    },
    container: {
      outside_color: "#FFFFFF",
      fill_color: "#FFFFFF",
      edge_color: "#F9FAFB",
      edge_weight: 1,
      edge_radius: 16,
    },
  },
};
